"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerUIActivePortValidation = void 0;
class ChargerUIActivePortValidation {
    static isValid(entity) {
        // If entity.active_port_id exists, validate that it has the correct type.
        if (entity.active_port_id != undefined) {
            if (typeof entity.active_port_id !== "number")
                return false;
        }
        return true;
    }
}
exports.ChargerUIActivePortValidation = ChargerUIActivePortValidation;
